module.exports = __webpack_public_path__ + "static/media/YM74_3.d764dd14.jpg";